import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import BrandLogo from './BrandLogo';
import { SITE } from '../config/site';

export default function Header({ onOpenCart }) {
  const { totalItems } = useCart();
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [q, setQ] = useState('');

  const links = [
    { to: '/', label: 'Inicio' },
    { to: '/catalogo', label: 'Catálogo' },
    { to: '/catalogo-unas', label: 'Uñas' },
    { to: '/como-comprar', label: 'Cómo comprar' },
    { to: '/#nosotros', label: 'Nosotros' },
    { to: '/contacto', label: 'Contacto' },
  ];

  function submitSearch(e) {
    e.preventDefault();
    const term = q.trim();
    setSearchOpen(false);
    setMenuOpen(false);
    navigate(term ? `/catalogo?q=${encodeURIComponent(term)}` : '/catalogo');
  }

  return (
    <header className="store-header">
      <div className="store-header-inner">
        <button
          type="button"
          className="store-menu-btn"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menú"
        >
          ☰
        </button>

        <BrandLogo variant="header" />

        <nav className={`store-nav ${menuOpen ? 'open' : ''}`}>
          {links.map((l) => (
            <Link
              key={`${l.to}-${l.label}`}
              to={l.to}
              className={
                l.to === '/contacto'
                  ? location.pathname === '/contacto'
                    ? 'active'
                    : ''
                  : l.to === '/como-comprar'
                    ? location.pathname === '/como-comprar'
                      ? 'active'
                      : ''
                  : l.to === '/catalogo-unas'
                    ? location.pathname === '/catalogo-unas'
                      ? 'active'
                      : ''
                    : l.to === '/catalogo'
                      ? location.pathname === '/catalogo' || location.pathname === '/tienda'
                        ? 'active'
                        : ''
                      : location.pathname === l.to
                        ? 'active'
                        : ''
              }
              onClick={() => setMenuOpen(false)}
            >
              {l.label}
              {l.badge ? <em className="nav-badge">{l.badge}</em> : null}
            </Link>
          ))}
        </nav>

        <div className="store-header-actions">
          <button
            type="button"
            className="header-icon-btn"
            onClick={() => setSearchOpen((v) => !v)}
            aria-label="Buscar"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
              <circle cx="11" cy="11" r="7" />
              <path d="M20 20l-3.5-3.5" />
            </svg>
          </button>
          <a
            className="header-icon-btn desktop-only-link"
            href={`https://wa.me/${SITE.whatsapp}`}
            target="_blank"
            rel="noreferrer"
            aria-label="WhatsApp"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12.04 2C6.58 2 2.15 6.4 2.15 11.84c0 1.97.52 3.8 1.44 5.4L2 22l4.92-1.55a9.86 9.86 0 0 0 5.12 1.4h.01c5.46 0 9.89-4.4 9.89-9.84C21.94 6.4 17.5 2 12.04 2zm5.76 14.05c-.24.68-1.4 1.25-1.95 1.33-.5.07-1.13.1-1.83-.12-.42-.13-.97-.32-1.67-.63-2.94-1.27-4.86-4.23-5.01-4.43-.15-.2-1.22-1.62-1.22-3.1 0-1.47.77-2.2 1.05-2.5.27-.3.6-.37.8-.37h.58c.19 0 .44-.07.69.53.24.6.83 2.03.9 2.18.07.15.12.32.02.52-.1.2-.15.32-.3.5-.15.17-.31.38-.44.51-.15.15-.3.31-.13.6.17.3.76 1.25 1.63 2.02 1.12 1 2.07 1.3 2.37 1.45.3.15.47.12.65-.07.17-.2.75-.87.95-1.17.2-.3.4-.25.68-.15.27.1 1.73.81 2.02.96.3.15.5.22.57.35.08.12.08.72-.16 1.4z" />
            </svg>
          </a>
          <button type="button" className="store-cart-btn" onClick={onOpenCart} aria-label="Carrito">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 6h15l-1.5 9h-12z" />
              <path d="M6 6L5 3H2" />
              <circle cx="9" cy="20" r="1.5" />
              <circle cx="18" cy="20" r="1.5" />
            </svg>
            <span className="store-cart-count">{totalItems}</span>
          </button>
        </div>
      </div>

      {searchOpen ? (
        <form className="store-search-bar" onSubmit={submitSearch}>
          <input
            type="search"
            placeholder="¿Qué estás buscando?"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            autoFocus
          />
          <button type="submit">Buscar</button>
        </form>
      ) : null}
    </header>
  );
}
